import styled, { css } from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import Avatar from '@deprecated-ui/common/Avatar';
import Checkbox from '@deprecated-ui/common/Checkbox';
import ModalAntd from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import SearchAutocomplete from 'global/SearchAutocomplete';
import { Input } from 'antd';

const { TextArea } = Input;

interface AvatarWrapperProps {
  selected?: boolean;
}

const Modal = styled(ModalAntd)`
  .ant-modal-content {
    border-radius: 3px;
  }
  .ant-modal-header {
    border-color: ${color.gainsboro};
    border-radius: 3px 3px 0 0;
    height: 66px;
    padding: 0 20px !important;

    .ant-modal-title {
      padding: 22px 0;
      border-bottom: solid 1px ${color.gainsboro};
    }
  }
  .ant-modal-body {
    padding: 20px;
    border-radius: 0 0 3px 3px;
  }
  .ant-modal-footer {
    padding: 0 !important;
    text-align: left;
    display: flex;
  }
  .ant-modal-close {
    top: 14px;
    right: 14px;

    .ant-modal-close-x {
      width: 40px;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
    }
  }
`;

const IconMedia = styled(Flex).attrs((props) => ({
  // @ts-expect-error
  background: props.background || 'none',
  align: 'center',
  justify: 'center',
}))`
  background-color: ${(props) => props.background};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
  cursor: pointer;

  ${
    // @ts-expect-error
    ({ bordered }) =>
    bordered &&
    css`
      border: solid 1px ${color.gainsboro};
    `}

  img {
    background: none;
    padding: 10px;
    width: 100%;
    height: 100%;
  }
`;

const ButtonAction = styled(Button)`
  background: ${color.snow};
  border: solid 0.5px ${color.gainsboro};
  border-radius: 7px;
  cursor: pointer;
  height: 40px;
  position: relative;
  width: 100%;

  &:hover,
  &:active,
  &:focus {
    background: ${color.snow};
    border-color: ${color.gainsboro};
  }

  &:first-child {
    margin-right: 14px;
  }

  &:last-child {
    margin-left: 14px;
  }
`;

const SectionWrapper = styled.section`
  border-bottom: solid 0.5px ${color.gainsboro};
  margin-bottom: 15px;
  max-height: 200px;
  overflow-y: auto;
  padding-bottom: 15px;
`;

const AvatarWrapper = styled.div<AvatarWrapperProps>`
  border: solid 1px;
  border-color: transparent;
  border-radius: 50%;
  cursor: pointer;
  margin-bottom: 5px;

  ${({ selected }) =>
    selected &&
    css`
      border-color: ${color.primary};
    `}
`;

const SelectedIconWrapper = styled(IconWrapper)`
  background: ${color.primary};
  border-radius: 50%;
  bottom: 5px;
  position: absolute;
  right: 2px;
`;

const Autocomplete = styled(SearchAutocomplete)`
  margin-bottom: 20px;

  .ant-input-affix-wrapper {
    border-color: ${color.snow};
    border-radius: 5px;
    height: 45px;
    background-color: ${color.snow};

    input {
      background-color: ${color.snow};
      padding-left: 5px;
    }

    input::placeholder {
      font-family: var(--font-bold);
      color: #c4c4c4;
    }

    :hover {
      border: unset;
    }
  }
`;

const UserCheckbox = styled(Checkbox).attrs({
  checkboxType: 'primary',
})`
  .ant-checkbox {
    .ant-checkbox-inner {
      border-radius: 50%;
      height: 25px;
      width: 25px;

      &::after {
        height: 11.142857px;
        left: 25%;
        width: 7.714286px;
      }
    }
  }
`;

const Textarea = styled(TextArea)`
  background-color: ${color.snow};
  border-color: ${color.gainsboro};
  border-radius: 12px;
  font-family: 'ProximaNovaRg';
  line-height: 1.4;
  resize: none;
  width: 85%;

  &.ant-input {
    height: 40px;
    min-height: 40px;
  }

  ::placeholder {
    font-family: var(--font-bold);
  }

  :hover,
  :focus {
    border-color: ${color.gainsboro};
    box-shadow: none;
  }
`;

const ButtonSend = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

const GroupAvatar = styled.span`
  width: 50px;
  height: 50px;
  line-height: 50px;
  display: block;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  border-radius: 100%;
  overflow: hidden;
  background: #ebf8f3;
  color: #00ab6b;
  i {
    font-style: normal;
  }
`;

const AvatarContainer = styled(Avatar)`
  & > img {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    border: 1px solid ${color.component};
    background: ${color.lowgray};
  }
`;

// eslint-disable-next-line import/prefer-default-export
export {
  Modal,
  IconMedia,
  ButtonAction,
  SectionWrapper,
  AvatarWrapper,
  SelectedIconWrapper,
  Autocomplete,
  UserCheckbox,
  Textarea,
  ButtonSend,
  GroupAvatar,
  AvatarContainer,
};
